import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { StatisticsMemberGrowthOverview } from '../components/statisticsMemberGrowthOverview';
import { StatisticsPaymentDistributionOverview } from '../components/statisticsPaymentDistributionOverview';

export const StatisticsDashboardPage = () => {
  const { t } = useTranslation();
  const { currentUser } = useGlobals();

  const hasInvoicePermission = getPermission(currentUser, PermissionEnum.InvoiceRead);

  return (
    <Grid container spacing={3}>
      <Grid item xs>
        <MainContentHeader title={t('statistics:title')} />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} xl={11} display='flex' flexDirection='column'>
            <StatisticsMemberGrowthOverview />
          </Grid>
          {hasInvoicePermission && (
            <Grid item xs={12} xl={11} display='flex' flexDirection='column'>
              <StatisticsPaymentDistributionOverview />
            </Grid>
          )}
          {/* <Grid item xs={12}>
          <StatisticsOverviewAgeDistribution />
        </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
};
